import React from 'react';
import CloudIcon from '@mui/icons-material/Cloud';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import GroupsIcon from '@mui/icons-material/Groups';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import PsychologyIcon from '@mui/icons-material/Psychology';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import { motion } from 'framer-motion';
import setup from '../assets/data/setup.json';
import MotionSection from './ui/MotionSection';
import SectionHeader from './ui/SectionHeader';

const iconMap: Record<string, React.ReactNode> = {
  cloud: <CloudIcon sx={{ fontSize: 24 }} />,
  automation: <AutoFixHighIcon sx={{ fontSize: 24 }} />,
  crm: <GroupsIcon sx={{ fontSize: 24 }} />,
  erp: <BusinessCenterIcon sx={{ fontSize: 24 }} />,
  ai: <PsychologyIcon sx={{ fontSize: 24 }} />,
  'cloud-integration': <CloudSyncIcon sx={{ fontSize: 24 }} />,
};

function WhatIBuild() {
  const items = setup.businessProblems;

  return (
    <MotionSection id="what-i-build">
      <SectionHeader
        eyebrow="What I deliver"
        title="Business Problems I Solve"
        subtitle="The same engineering work—described the way a business owner thinks about it."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 12, filter: 'blur(4px)' }}
            whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: index * 0.04, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -3 }}
            className="group ui-card ui-card-lift p-5 sm:p-6"
          >
            <div className="w-11 h-11 rounded-lg border border-line bg-canvas-muted flex items-center justify-center text-ink-secondary mb-4 group-hover:border-accent/30 transition-colors">
              {iconMap[item.icon]}
            </div>
            <h3 className="text-[15px] font-semibold text-ink mb-2 tracking-[-0.01em]">
              {item.title}
            </h3>
            <p className="text-sm text-ink-muted leading-relaxed">{item.description}</p>
          </motion.div>
        ))}
      </div>
    </MotionSection>
  );
}

export default WhatIBuild;
